import { formatPhoneNumber } from 'utils';
import template from './multi_conf_modal.html';

angular.module('bb.appointments').component('multiConfModal', {
  controller: MultiConfController,
  controllerAs: 'vm',
  template,
  bindings: {},
});

MultiConfController.$inject = ['AppointmentConfigService', 'ModalService'];

function MultiConfController(AppointmentConfigService, ModalService) {
  const vm = this;

  vm.multiConfModal = ModalService.multiConfModal;

  vm.formatPhoneNumber = formatPhoneNumber;

  vm.validateMultiConf = () =>
    vm.multiConfModal.contacts &&
    vm.multiConfModal.contacts.filter(contact => contact.mustConfirm).length !==
      1;

  vm.saveMultiConf = () => {
    const multiConfirm =
      vm.multiConfModal.contacts.filter(contact => contact.mustConfirm).length >
      1;

    if (multiConfirm) {
      vm.multiConfModal.contacts = vm.multiConfModal.contacts.map(contact => ({
        ...contact,
        canConfirmAppts: contact.canConfirmAppts && contact.mustConfirm,
        canDenyAppts: contact.canDenyAppts && contact.mustConfirm,
        canSuggestTime: contact.canSuggestTime && contact.mustConfirm,
      }));
    }

    AppointmentConfigService.updateConfigContacts({
      listingId: vm.multiConfModal.listingId,
      contacts: vm.multiConfModal.contacts,
    }).then(({ updatedContacts }) => {
      ModalService.closeMultiConfModal(updatedContacts);
    });
  };
}
